import { Container, Nav, Navbar } from "react-bootstrap";
import styles from './Footer.module.css';

export default function Footer() {
    const currentVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content');

    return (
        <footer className={styles.footer}>
            <Navbar>
                <Container fluid>
                    <Nav>
                        
                    </Nav>
                    <Nav>
                        <Navbar.Text>
                            v{currentVersion}
                        </Navbar.Text>
                    </Nav>
                </Container>
            </Navbar>
        </footer>
    );
}